export const CONTACT_EMAIL = "paradise.corp@outlook.com";
